import {z} from "zod";

export const createProgramSchema = z
    .object({
        status: z.string(),
        programTypeId: z.number({message: "fieldRequired"}).min(1, "fieldRequired"), // state placeholder (not sent to backend)
        cycleYear: z.number({message: "fieldRequired"}).min(1, "fieldRequired"), // state placeholder (not sent to backend)
        numberOfActiveOrder: z.number({message: "fieldRequired"}).min(1, "fieldRequired"),
        isFileAttachmentHidden: z.boolean().optional(),
        programManagerId: z.string().optional(),
        isFileAttachmentRequired: z.boolean().optional(),
        isCentreManagementHidden: z.boolean().optional(),
        isCentreManagementRequired: z.boolean().optional(),
        isResearchFieldHidden: z.boolean().optional(),
        isResearchFieldRequired: z.boolean().optional(),
        isFromSubjectHidden: z.boolean().optional(),
        isFromSubjectRequired: z.boolean().optional(),
        programDetails: z.array(
            z.object({
                displayName: z.string().min(1, "fieldRequired"),
                description: z.string().min(3, "fieldLength"),
                ruleAndConditionName: z.string().min(1, "fieldRequired"),
                ruleAndConditionTemplate: z.string().min(1, "fieldRequired"),
                commitmentName: z.string().min(1, "fieldRequired"),
                commitmentTemplate: z.string().min(1, "fieldRequired"),
                fileAttachmentLabel: z.string().optional(),
                centreManagementLabel: z.string().optional(),
                researchFieldLabel: z.string().optional(),
                fromSubjectLabel: z.string().optional(),
                locale: z.enum(["En", "Ar"]),
            }),
        ),
        classificationProgramId: z.number().min(1, "fieldRequired"),
        // min date 1/1/2023
        contractStartDate: z.date({message: "fieldRequired"}).min(new Date(2023, 0, 1), "fieldRequired"),
        fundingDurationInMonths: z.number().min(0).optional(),
        adsStartDate: z.date({message: "fieldRequired"}).min(new Date(2023, 0, 1), "fieldRequired"),
        adsEndDate: z.date().nullish(),
        fundingAmount: z.number().min(0).optional(),
        audienceTypesIds: z.array(z.number()).min(1, "fieldRequired"),
        programCycleId: z.number({message: "fieldRequired"}).min(1, "fieldRequired"),
        adsImageId: z.string().optional(),
        contractId: z.number().optional(),
        workflowGid: z.string({message: "fieldRequired"}).min(1, "fieldRequired"),
        financingCalculationItems: z.array(
            z
                .object({
                    financingTypeId: z.number({message: "fieldRequired"}).min(1, "fieldRequired"),
                    calculationWay: z.string().nullish(), // state placeholder (not sent to backend)
                    notes: z.string().nullish(),
                    fromValue: z.number({message: "fieldRequired"}).min(1, "fieldRequired"),
                    toValue: z.number({message: "fieldRequired"}).min(1, "fieldRequired"),
                })
                .refine((data) => data.fromValue <= data.toValue, {
                    message: "fromValueLessThanOrEqualToValue",
                    path: ["fromValue"],
                }),
        ),
        formBuilderSchema: z.string(),
        programAttachmentsIds: z.array(z.string()),
    })
    .refine((data) => (data.adsEndDate && data.adsEndDate > data.adsStartDate) ||!data.adsEndDate , {
        message: "adsEndDateGreaterThanAdsStartDate",
        path: ["adsEndDate"],
    });

export type CreateProgramRequest = z.infer<typeof createProgramSchema>;
